var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky flex flex-col items-center self-start flex-1 w-full py-2 md:w-auto top-16"},[_c('NewsletterForm',{staticClass:"md:pl-6 md:pr-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }